// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react: true*/
import {useMemo} from 'react';
import {guess_browser} from 'zuser_agent';
import {use_install_info} from './use_install_info';
import * as ui_links from './ui_install_links';

const stores = {
    chrome: 'Chrome Web Store',
    firefox: 'Firefox add-on store',
    opera: 'Opera add-on store',
    edge: 'Edge add-on store',
    safari: 'Apple Store',
    huawei: 'Huawei app gallery',
    // XXX dmitriikup: URG request from noav to remove all Samsung
    // mentions from www
    // samsung: 'Samsung Galaxy Store',
    ios: 'App Store',
    fireos: 'Appstore',
};

const devices = {
    tvos: 'AppleTV',
    fireos: 'FireTV',
    webos: 'LG',
    xbox: 'Xbox',
    ps: 'Playstation',
    windows: 'Windows',
    macos: 'MacOS',
};

const links = {
    chrome: ui_links.chrome_href,
    firefox: ui_links.firefox_href,
    opera: ui_links.opera_href,
    edge: ui_links.edge_href,
    safari: ui_links.apple_href,
};

interface i_use_device_info_props {
    host?: string;
    download_browser?: boolean;
    download_vpn?: boolean;
    user_country?: string;
    app_fixed?: string;
}
export const use_product_info = (props: i_use_device_info_props = {})=>{
    const {host, download_browser, download_vpn, user_country,
        app_fixed} = props;
    const {app, href, os, browser} = use_install_info({host, download_browser,
        download_vpn, user_country, app_fixed});
    const b = guess_browser();
    const info = useMemo(()=>{
        if (app=='browser')
            return {app, os, href, peer: true};
        if (app=='vpn')
            return {app, os, href, device: devices[os], peer: true};
        const store = stores[os] || stores[browser] || 'download page';
        if (app=='ext')
            return {app, os, store, href: href||links[browser]};
        if (app=='tv')
            return {app, os, device: devices[os], href, peer: os!='tvos'};
        if (app=='console')
            return {app, os, device: devices[os], href};
        if (app=='mobile')
            return {app, os, store, href};
        return {app, os, store, href: href||links[browser]};
    }, [b, os, browser, href]);
    return info;
};
